import React, {Component} from 'react';
import {connect} from "react-redux";
import size from 'lodash/size';
import {FormattedMessage} from "react-intl";

import {setInstList} from "../../actions/actionFunctions";
import Quantity from "../ui/quantity";
import Analytics from './../../analytics';
import {getPriceWithCurrency, toFixedPrice} from "../../misc/helpers";

class InstList extends Component {

  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     openedGroups: []
  //   };
  // }

  handleRadioButtonClick = (e) => {
    const clickedIndex = +e.target.closest('.ui-radio').dataset.index;
    this.props.setInstList(this.props.instList.map((instGroup, index) => {
      if (index === clickedIndex) {
        Analytics.sendClickEvent('installation-group-selected-' + instGroup.title);
        instGroup.enabled = !instGroup.enabled
      }
      return instGroup
    }));
  };

  handleServiceClick = (groupIndex, serviceIndex) => {
    Analytics.sendClickEvent('installation-service-clicked-' + groupIndex + '-' + serviceIndex);
    this.props.setInstList(this.props.instList.map((instGroup, index) => {
      if (index === +groupIndex) {
        instGroup.services = instGroup.services.map((service, index2) => {
          if (index2 === +serviceIndex) {
            service.selected = !service.selected
          }
          return service
        })
      }
      return instGroup
    }));
  };

  updateServiceValue = (groupIndex, serviceIndex, valueName, value) => {
    Analytics.sendDataEnteredEvent('installation-service-value-' + valueName);
    this.props.setInstList(this.props.instList.map((instGroup, index) => {
      if (index === +groupIndex) {
        instGroup.services = instGroup.services.map((service, index2) => {
          if (index2 === +serviceIndex) {
            service[valueName] = value;
          }
          return service
        })
      }
      return instGroup
    }));
  };

  getSublistHeight = (servicesLength, enabled) => {
    return enabled ? servicesLength * 80 : 0
  };

  // getItems = () => {
  //   const {cartState} = this.props;
  //   const cartItems = cartState.cartItems;
  //   let installations = flatMap(this.props.defaultInstallations, i =>  i.installations);
  //   const items = [];
  //
  //   cartItems.forEach(ci => {
  //     const installation = find(installations, {fabricatorFeature_id: ci.cartFeature.dbFeature.id});
  //     if (installation) {
  //       let idx = indexOf(items, {title: ci.selectionGroup});
  //       if (idx === -1) {
  //         items.push({title: ci.selectionGroup,
  //           description: 'Do you want to installation for ' + ci.selectionGroup,
  //           services: []});
  //         idx = items.length - 1;
  //       }
  //
  //       items[idx].services.push({
  //         title: installation.installationName,
  //         hourly: installation.price,
  //       });
  //     }
  //   });
  //
  //   return items;
  // }

  render() {
    const fabricatorSettings = this.props.fabricatorData.settings;
    return (
      <ul className="inst-list">
        {this.props.instList.map((instGroup, index) => {
          if (instGroup.services.every(service => service.autoAddWithProduct)) {
            return null
          }
          return (
            <li className="inst-list__item" key={"instGroup" + index}>
              <div className="service">
                <div className={"service-image icon--" + instGroup.title.toLowerCase().replace(/ /g,"-")}/>
                <div className="service-main">
                  <h4 className="service-main__title bold">{instGroup.title}</h4>
                  <p className="service-main__description">{instGroup.description}</p>
                </div>
                <div className="service-radio">
                  <button className={"ui-radio" + (instGroup.enabled ? " ui-radio--checked" : "")}
                          data-index={index}
                          onClick={this.handleRadioButtonClick}>
                    <span className="ui-radio-circle"/>
                    <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.yes"/></span>
                    <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.no"/></span>
                  </button>
                </div>
              </div>
              {size(instGroup.services) ? (
                <ul className={"inst-sublist"}
                    style={{height: this.getSublistHeight(instGroup.services.length, instGroup.enabled)}}>
                  {instGroup.services.map((service, index2) => {
                    return (
                      <li className="inst-sublist__item" key={"service" + index2}>
                        <div className="subservice">
                          <div className="subservice-checkbox">
                            <button className={"ui-checkbox" + (service.selected ? " ui-checkbox--checked" : "")}
                                    onClick={() => this.handleServiceClick(index, index2)}/>
                          </div>
                          <div className="subservice-title bold">
                            {service.title}
                            <p className='subservice-title-description'>{service.description}</p>
                          </div>
                          <div
                            className={"subservice-quantity" + (!service.selected ? " subservice-quantity--disabled" : "")}>
                            <Quantity value={service.hourly} size="normal" title={service.unit || "Quantity"}
                                      changeValue={value => this.updateServiceValue(index, index2, 'hourly', value)} minValue={1}
                                    hideQuantity={service.hideQuantity} defaultQuantity={service.defaultQuantity}/>
                          </div>
                          <div className='subservice-price'>
                            <div className='subservice-price-title'><FormattedMessage id="installations.price"/></div>
                            <div className='subservice-price-amount bold'>
                              {getPriceWithCurrency(fabricatorSettings, toFixedPrice(service.hourly * service.price))}
                            </div>
                          </div>
                        </div>
                      </li>
                    )
                  })}
                </ul>
              ) : null}
            </li>
          )
        })}
      </ul>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    instList: store.instState.instList,
    defaultInstallations: store.instState.defaultInstallations,
    fabricatorData: store.fabricatorState,
  };
};

export default connect(mapStateToProps, {
  setInstList
})(InstList);
